import { createSelector } from "@reduxjs/toolkit";

import { selectEditor } from "./flowEditorSlice";

export const selectPreviewPrompt = createSelector(selectEditor, (editor) => {
  if (editor.flow == null) return null;
  if (editor.flow.definition.promptsArray.length === 0) return null;
  return editor.flow.definition.promptsArray[editor.previewPromptIndex];
});
